<template>
  <div class="tdt-map" ref="map" style="width: 100%; height: 500px"></div>
</template>

<script>
import loadTDT from "@/utils/loadTDT.js";

export default {
  name: "TdtMap",
  props: {
    tk: { type: String, required: true },
    center: {
      // [lng, lat]
      type: Array,
      default: () => [116.40769, 39.89945], // 北京
    },
    zoom: { type: Number, default: 12 },
    // useImageBase: { type: Boolean, default: false }, // 是否使用影像底图
    markers: {
      // 标记点数组，data用于生成模板
      type: Array,
      default: () => [],
      // 例如：[{ lng: 121.33, lat: 30.74, data: { address: 'xxx', houseDescribe: 1 }}]
    },
  },
  data() {
    return {
      map: null,
      // baseLayer: null,
      // labelLayer: null,
      markerList: [],
    };
  },
  async mounted() {
    const T = await loadTDT(this.tk);

    this.$nextTick(() => {
      this.initMap(T);
      });
  },
  methods: {
    initMap(T) {
      this.map = new T.Map(this.$refs.map, { projection: "EPSG:3857" });
      const center = new T.LngLat(this.center[0], this.center[1]);
      this.map.centerAndZoom(center, this.zoom);
      this.map.enableScrollWheelZoom();


      // this.baseLayer = new T.TileLayer.Vector.Map();
      // this.labelLayer = new T.TileLayer.Vector.Annotion();
      // this.map.addLayer(this.baseLayer);
      // this.map.addLayer(this.labelLayer);

      
        if (this.markers && this.markers.length) {
          this.addMarkers(T);
        }
      

      this.map.addControl(new T.Control.Scale());
      this.map.addControl(new T.Control.Zoom());
      // this.map.addControl(new T.Control.MapType());

      this.map.addEventListener("click", (e) => {
        const { lng, lat } = e.lnglat;
        this.$emit("map-click", { lng, lat });
      });
    },

    // 添加标记点
    addMarkers(T) {
      this.markerList.forEach((m) => this.map.removeOverLay(m));
      this.markerList = [];

      this.markers.forEach((item) => {
        const point = new T.LngLat(item.lng, item.lat);

        // 设置自定义图标
        let markerOpts = {};
        if (item.icon) {
          const icon = new T.Icon({
            iconUrl: item.icon,
            iconSize: new T.Point(32, 32),
            iconAnchor: new T.Point(16, 32),
          });
          markerOpts.icon = icon;
        }

        const marker = new T.Marker(point, markerOpts);
        this.map.addOverLay(marker);

        // 使用传入的 data 动态生成 content
        const content = this.buildInfoWindowContent(item || {});

        const infoWindow = new T.InfoWindow(content, {
          offset: new T.Point(0, -20),
        });

        this.map.openInfoWindow(infoWindow, point);

        marker.addEventListener("click", () => {
          this.map.openInfoWindow(infoWindow, point);
        });

        this.markerList.push(marker);
      });
    },

    // 构造 InfoWindow 内容
    buildInfoWindowContent(item) {
      return `
      <div style="width:100%;display:flex;flex-direction:row;align-items:flex-start;">
      <!-- 左侧图片 -->
      <div style="flex:0 0 80px; margin-right:10px;">
        <img src="${item.housePic || "/images/default-house.png"}" 
            style="width:100px;height:120px;object-fit:cover;border-radius:4px;" />
      </div>
        <!-- 右侧文字内容 -->
      <div style="flex:1;display:flex;flex-direction:column;line-height:1.4;">
        <div style="font-weight:bold;font-family:Microsoft YaHei;font-size:17px;color:#484848;margin-bottom:4px;">
          ${item.data.address || "未知地址"}
        </div>
        <div style="display:flex;flex-direction:row;margin:4px 0 2px 0;">
          <div style="font-family:Microsoft YaHei;font-size:14px;color:#484848;">房屋属性：</div>
          <div style="margin-top: 2px;">
            ${
              item.data.houseType == 1
                ? "商铺"
                : item.data.houseType == 2
                ? "写字楼"
                : item.data.houseType == 3
                ? "综合体"
                : item.data.houseType == 4
                ? "厂房"
                : item.data.houseType == 5
                ? "其他商业"
                : "居住"
            }
          </div>
        </div>
        <div style="display:flex;flex-direction:row;margin:2px 0;">
          <div style="font-family:Microsoft YaHei;font-size:14px;color:#484848;">装修现状：</div>
          <div style="margin-top: 2px;">${item.data.decorate || "简装"}</div>
        </div>
        <div style="display:flex;flex-direction:row;margin:2px 0;">
          <div style="font-family:Microsoft YaHei;font-size:14px;color:#484848;">周边公共交通：</div>
          <div style="margin-top: 2px;">${item.data.traffic || "暂无"}</div>
        </div>
      </div>
    </div>
    `;
    },
  },
  watch: {
    markers: {
      handler() {
        if (!this.map || !window.T) {
          setTimeout(() => {
            if (this.map && window.T) {
              this.addMarkers(window.T);
            }
          }, 300);
        } else {
          this.addMarkers(window.T);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
